/* eslint-disable */
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import BarChartIcon from '@material-ui/icons/BarChart';
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Page from '../../Components/Page/Page.component';
import withServices from '../../Contexts/Services/WithServices.context';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import './Reports.page.i18n';
import ReportsPagePropTypes from './Reports.page.props';
import ReportsPageSidebar from './Reports.page.sidebar';
import reportsPageStyles from './Reports.page.styles';

/**
 * ReportsPageComponent
 * @export
 * @class ReportsPageComponent
 * @extends {React.Component<ReportsPageComponentComposedProps, ReportsPageComponentState>}
 */
export class ReportsPageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<ReportsPageComponentProps>}
   * @memberof ReportsPageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`ReportsPage`}
   * @memberof ReportsPageComponent
   */
  static displayName = `ReportsPage`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof ReportsPageComponent
   */
  static propTypes = ReportsPagePropTypes;

  /**
   * Data specific to the `<ReportsPage />` instance
   * @type {ReportsPageComponentState}
   * @memberof ReportsPageComponent
   */
  state = {};

  /**
   * Render the component
   * @returns {React.Component} The rendered `<ReportsPage />`
   * @memberof ReportsPageComponent
   */
  render() {
    const { classes, width } = this.props;
    const isSmall = isWidthDown(`xs`, width);
    const isLarge = isWidthUp(`lg`, width);
    return (
      <Page
        className={classes.root}
        heading="ReportsPage.PageTitle"
        hideLogo={isSmall}
        hideMenuIcon={isLarge}
        sidebarContent={<ReportsPageSidebar />}
        title="ReportsPage.PageTitle"
      >
        {` `}
        <Grid container item sm={8} xs={12}>
          <Grid container item sm={8} xs={12}>
            <Grid item>
              <Typography className={classes.marginBottom1unit} variant="caption">
                Delivery reports
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid container item sm={8} xs={12}>
          <Link className={classes.link} to="/report/volume">
            <Grid alignItems="center" classes={{ container: classes.reportType }} container item spacing={2} wrap="nowrap">
              <Grid item>
                <Avatar>
                  <BarChartIcon />
                </Avatar>
              </Grid>
              <Grid item>
                <Typography className={classes.link} variant="subtitle1">
                  Volume Report
                </Typography>
              </Grid>
            </Grid>
          </Link>
        </Grid>
        <Grid container item sm={8} xs={12}>
          <Link className={classes.link} to="/report/docket-detail">
            <Grid alignItems="center" classes={{ container: classes.reportType }} container item spacing={2} wrap="nowrap">
              <Grid item>
                <Avatar>
                  <BarChartIcon />
                </Avatar>
              </Grid>
              <Grid item>
                <Typography className={classes.link} variant="subtitle1">
                  Docket Detail Report
                </Typography>
              </Grid>
            </Grid>
          </Link>
        </Grid>
      </Page>
    );
  }
}

/** @type {React.ComponentClass<ReportsPageComponentProps>} */
const ReportsPage = compose(
  withWidth(),
  withRouter,
  withServices,
  withStyles(themeCreateInjectableStyles(reportsPageStyles), { withTheme: true }),
)(ReportsPageComponent);

export default ReportsPage;
